import {Button, CardActions} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import React, {useEffect, useState} from 'react'
import styles from './ShowPhotoDialog.module.scss'
import {useDispatch, useSelector} from 'react-redux'
import {
  setIsShowPhotoOpen,
} from '../../redux/actions'
import BasicModal from '../Generic/BasicModal'


export const ShowPhotoDialog = () => {
  const isShowPhotoOpen = useSelector(state => state.getIn(['general','isShowPhotoOpen']))
  const showPhotoUrl = useSelector(state => state.getIn(['general','showPhotoUrl']))
  const name = showPhotoUrl?.indexOf('hallucination') > -1 ? 'hallucination' : 'photo'
  const dispatch = useDispatch()
  const [intervalRef, setIntervalRef] = useState()
  const setIsOpen = (isOpen) => { dispatch(setIsShowPhotoOpen(isOpen)) }

  useEffect(() => {

    if (isShowPhotoOpen) {
      const interval = setInterval(() => {
          dispatch(setIsShowPhotoOpen(false))
        }, 5000
      )
      setIntervalRef(interval)
    } else {
      clearInterval(intervalRef)
    }
  }, [isShowPhotoOpen])


  return <BasicModal
    isOpen={!!isShowPhotoOpen}
    setIsOpen={setIsOpen}
    title={name}
    content={<div className={styles.container}>
      <img className={styles.image} src={showPhotoUrl} alt="image"/>
    </div>}
    footer={<div>
      <div className={styles.closeContainer}>
        <CardActions sx={{justifyContent: "center"}}>
          <Button onClick={() => setIsOpen(false)}
                  variant="contained"
                  color="primary"
                  type="button"
                  style={{fontSize: '22px'}}
                  startIcon={<CloseIcon/>}
          >Close</Button>
        </CardActions>
      </div>
    </div>}
  />
}
